const my_profile = {
  viewMyClubSeacretProfile: "Peržiūrėti mano ClubSeacret profilį", // translated
  viewMoreDetails: "Žiūrėti daugiau informacijos", // translated
  verifiedEmail: "Patvirtintas el", // translated
  unverifiedEmail: "Nepatvirtintas el", // translated
  balance: "Balansas", // translated
  pointsIn: "Taškai į", // translated
  pointsOut: "Atkreipia dėmesį į", // translated
  topUp: "Prisipilti", // translated
  pointsHistoryTable: "Taškų istorijos lentelė", // translated
  createdFrom: "Sukurta nuo", // translated
  createdTo: "Sukurtas iki", // translated
  selectStatus: "Pasirinkite būseną...", // translated
  searchByTitle: "Ieškoti pagal pavadinimą...", // translated
  pushNotifications: "Push pranešimai", // translated 
  pushNotificationsDescription: "įsigyti naršyklės pranešimus apie svarbius atnaujinimus ir įvykius", // translated 
  pushNotificationsNotSupported: "Push pranešimai šioje naršyklėje nepalaikomi", // translated 
  pushNotificationsDeniedMessage: "Pranešimų leidimas buvo atmestas. Prašome įjungti pranešimus naršyklės nustatymuose, kad gautumėte push pranešimus.", // translated 
  pushNotificationsEnabled: "Push pranešimai sėkmingai įjungti", // translated 
  pushNotificationsDisabled: "Push pranešimai sėkmingai išjungti", // translated 
  userInformationMissing: "Trūksta vartotojo informacija", // translated 
  failedToUpdatePushNotifications: "Nepavyko atnaujinti push pranešimų nustatymų", // translated 
  notificationPermissionDenied: "Pranešimų leidimas buvo atmestas. Prašome jį įjungti naršyklės nustatymuose.", // translated 
  notificationPermissionRequired: "Reikalingas pranešimų leidimas, kad būtų įjungti push pranešimai", // translated 
  notSupported: "Nepalaikoma", // translated 
  permissionDenied: "Leidimas atmestas", // translated 
  permissionNotRequested: "Leidimas neprašytas", // translated 
  enabled: "Įjungta", // translated 
  disabled: "Išjungta", // translated 
};


export default my_profile;
